import {MenuItem} from '@/components/ui/menu-atoms/MenuAtoms'
import styled, {css} from 'styled-components'

export const StyledAgendaViewMenuItem = styled(MenuItem)<{$isActive?: boolean}>(
    ({theme: {palette}, $isActive}) => css`
        border-radius: 6px;
        font-weight: 400;
        ${$isActive &&
        css`
            background-color: ${palette.neutral['50']};
            font-weight: 600;
            &:hover {
                background-color: ${palette.neutral['50']};
            }
        `}
    `
)
